import * as yup from "yup";
import { axios } from "../../utils/axios";
import { toast } from "react-toastify";
import { toastOptions } from "../../config/toast";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tooltip from "@mui/material/Tooltip";

export const getArticulos = async (setIsLoading, setArticulos, setPrecioUnidad) => {
  setIsLoading(true);
  const result = await axios().get("get_articulos");
  const { data, error } = result.data;
  if (data) {
    setArticulos(data);
    // setPrecioUnidad(data.precio_unidad.value);
  }
  if (error) {
    toast.error(error, toastOptions);
  }
  setIsLoading(false);
};

export const onSubmitCreate = async (submittedData, setIsLoading, setAddArticuloModalIsOpen, setArticulos) => {
  setIsLoading(true);
  const result = await axios().post("create_articulo", submittedData);
  const { status } = result;
  const { data, error } = result.data;
  if (data) {
    setArticulos((prevState) => {
      const articulos = [...prevState, data];
      return articulos;
    });
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }

  setAddArticuloModalIsOpen(false);
  setIsLoading(false);
  return;
};

export const onSubmitEditPrecioUnidad = async (submittedData, setPrecioUnidad, setIsLoading, setCambiarPrecioUnidadModalIsOpenIsOpen) => {
  setIsLoading(true);
  const result = await axios().post("actualizar_precio_unidad", submittedData);
  const { status } = result;
  const { data, error } = result.data;

  if (data) {
    setPrecioUnidad(data.value);
    setCambiarPrecioUnidadModalIsOpenIsOpen(false);
    toast.success("Valor Precio Unidad cambiado correctamente", toastOptions);
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }

  setIsLoading(false);
};

export const tableData = (data, ua) => {
  const columns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "codigo",
      headerName: "Codigo",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "unidades",
      headerName: "Unidades",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "descripcion",
      headerName: "Descripcion",
      minWidth: 500,
      flex: 2,
      /* renderCell: (params) => {
        return (
          <Tooltip disableFocusListener  title={params.row.descripcion}>
          <IconButton>
          <VisibilityIcon />
          </IconButton>
          </Tooltip>
          );
      }, */
    },
    {
      hide: !ua.hasRole("tribunales"),
      field: "puntos",
      headerName: "Puntos",
      minWidth: 100,
      flex: 1,
    },
  ];

  const rows = data.map((d, index) => {
    return {
      id: d.id,
      codigo: d.codigo,
      descripcion: d.descripcion,
      unidades: d.unidades,
      puntos: d.puntos ?? "Sin especificar",
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();
    return String(d.codigo)?.toString().toLowerCase().includes(value) || String(d.descripcion)?.toLowerCase().includes(value);
  };

  return { columns, rows, filter };
};

export const articuloSchema = yup.object({
  codigo: yup.string("").required("Codigo requerido").max(500, "Maximo 500 caracteres"),
  descripcion: yup.string("").required("Descripcion requerida").max(500, "Maximo 500 caracteres"),
});

export const preciounidadSchema = yup.object({
  precio_unidad: yup
    .string()
    .matches(/^[0-9]+$/, "Solo números")
    .required("Precio unidad requerido"),
});
